"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
class Role {
    name;
    authority;
    permissions;
    override;
    /***
     * Role Constructor
     * @param {string} name
     * @param authority
     * @param {number} permissions
     * @param {number|null} override
     */
    constructor(name = null, authority = 1, permissions = 0, override) {
        this.name = name;
        this.authority = authority;
        this.permissions = permissions;
        this.override = override;
    }
    /***
     * Checks if this Role has a permission
     * @param {number} perm
     * @returns {boolean}
     */
    has = (perm) => ((BigInt(this.permissions) & BigInt(perm)) === BigInt(perm)) || (this.override !== null ? ((BigInt(this.permissions) & BigInt(this.override)) === BigInt(this.override)) : false);
    /***
     * Checks if this Role explicitly has a permission (without this.override override option)
     * @param {number} perm
     * @returns {boolean}
     */
    hasLiteral = (perm) => ((BigInt(this.permissions) & BigInt(perm)) === BigInt(perm));
    /***
     * Check if a role has authority over another role; The lowest value has the highest authority.
     * The top level authority value is 1, the lowest level is (2^53) - 1
     * @param {Role} role
     * @returns {boolean}
     */
    hasAuthorityOver = (role) => this.authority < role.authority;
    /***
     * Checks if a given permissions number contains a permission
     * @param {number} perms
     * @param {number} perm
     * @returns {boolean}
     */
    static has = (perms, perm) => ((BigInt(perms) & BigInt(perm)) === BigInt(perm));
    /***
     * Adds a permission to a Role
     * @param {number} perms
     * @returns {Role}
     */
    addPermission = (perms) => {
        this.permissions = Number(BigInt(this.permissions) | BigInt(perms));
        return this;
    };
    /***
     * Adds a list of permissions to a Role
     * @param {Array<number>} perms
     * @returns {Role}
     */
    addPermissions = (perms) => {
        perms.forEach((perm) => this.permissions = Number(BigInt(this.permissions) | BigInt(perm)));
        return this;
    };
    /***
     * Removes a permission from a Role
     * @returns {Role}
     * @param perm
     */
    removePermission = (perm) => {
        this.permissions = Number(BigInt(this.permissions) & ~BigInt(perm));
        return this;
    };
    /***
     * Removes a list of permissions from a Role
     * @returns {Role}
     * @param perms
     */
    removePermissions = (perms) => {
        perms.forEach((perm) => this.permissions = Number(BigInt(this.permissions) & ~BigInt(perm)));
        return this;
    };
}
exports.Role = Role;
exports.default = Role;
